import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RoleArrayModel, RoleModel } from "../../models/RoleModel";

const initialRoleState: RoleArrayModel = {
  all_Roles: [],
  particular_Role: {
    roleId: 0,
    name: "",
    description: "",
    roleLevel: "",
  },
  isRolesFetching: false,
};
const RoleSlice = createSlice({
  name: "Role",
  initialState: initialRoleState,
  reducers: {
    setRoles(state, action: PayloadAction<RoleModel[]>) {
      state.all_Roles = action.payload;
    },
    setParticularRole(state, action: PayloadAction<RoleModel>) {
      state.particular_Role = action.payload;
    },
    setIsRolesFetching(state, action: PayloadAction<boolean>) {
      state.isRolesFetching = action.payload;
    },
  },
});
export default RoleSlice;
